var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import { FileUploaderListItem } from '../FileUploaderListItem';
export var FileUploaderList = function (_a) {
    var files = _a.files, onRemove = _a.onRemove, onRefresh = _a.onRefresh, className = _a.className, props = __rest(_a, ["files", "onRemove", "onRefresh", "className"]);
    if (!(files === null || files === void 0 ? void 0 : files.length)) {
        return null;
    }
    return (React.createElement("div", __assign({ className: cn('lk-ui_file-uploader-file-list', className) }, props), files.map(function (file, index) {
        var name = file.name, _a = file.state, state = _a === void 0 ? 'upload' : _a, rest = __rest(file, ["name", "state"]);
        return (React.createElement(FileUploaderListItem, __assign({ key: index, name: name, state: state, onRefresh: onRefresh, onRemove: onRemove }, rest)));
    })));
};
